import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

function InterContact() {
  return (
    <div>
      <Navbar />
      <div className="custom__page">
        <div className="container">
          <div className="header__custom">
            <h4>Xalqaro aloqalar bo`limi</h4>
            <div className="card__custom">
              <div className="box__custom">
                <img src="img/1.png" alt />
              </div>
              <div className="box-1__custom">
                <p>Alijonova Kamila Taxirovna</p>
                <span>Bo`lim boshlig`i</span>
                <br />
                <br />
                <hr />
                <div className="wer__custom">
                  <div className="malinki__custom">
                    <p>E-pochta</p>
                    <span>kamilianalijanova@gmail.com</span>
                  </div>
                  <div className="malinki1__custom">
                    <p>Telefon nomer</p>
                    <span>+998(71) 2563825</span>
                  </div>
                 
                </div>
                <div className="wer__custom">

                 
                </div>
              </div>
            </div>
            <div className="card__custom">
              <div className="box__custom">
                <img src="img/2.png" alt />
              </div>
              <div className="box-1__custom">
                <p>Ibodullayev Mirjalol Sabirjonovich</p>
                <span>
                  Yoshlar bilan ishlash, ma`naviyat va ma`rifat bo`limi
                  boshlig`i
                </span>
                <br />
                <br />
                <hr />
                <div className="wer__custom">
                  <div className="malinki__custom">
                    <p>E-pochta</p>
                    <span>mirjalol7087@mail.ru</span>
                  </div>
                  <div className="malinki1__custom">
                    <p>Telefon nomer</p>
                    <span>+998(71) 2563825</span>
                  </div>
                
                </div>
                <div className="wer__custom">
                 
                
                </div>
              </div>
            </div>
          </div>
          <div className="card1__custom">
            <p>
              Xalqaro hamkorlik bo'limi institutning xorijiy va xalqaro
              tashkilotlar, universitetlar bilan hamkorligi va hamkorligini
              ta'minlash bo'yicha keng ko'lamli <br /> masalalar va vazifalar
              bilan shug'ullanadi, hamkorlikni mustahkamlash, xorijiy
              talabalarni jalb qilish, institut nufuzini oshirishga qaratilgan
              madaniy <br /> markazlar, konsulliklar va turli mamlakatlarning
              elchixonalari bilan hamkorlik qiladi.
              <br />
              <br />
              Bo'limning asosiy vazifalari: <br />
              • xalqaro hamkorlik dasturlarini shakllantirish, xalqaro
              hamkorlikni kengaytirish, xorijiy universitetlar va ilmiy
              tashkilotlar bilan hamkorlik qilish, xalqaro <br />
              assotsiatsiyalarda ishtirok etish; <br />
              • xalqaro ilmiy faoliyat, PPS va ilmiy xodimlarning akademik
              mobilligi sohasidagi xorijiy hamkorlar bilan universitet
              shartnomalari va kelishuvlarini <br /> monitoring qilish; <br />
              • xalqaro akademik mobillikni rivojlantirish va institutning ilmiy
              obro'sini oshirish; <br />
              • ikki diplom, akademik almashinuv va amaliyot dasturlarini amalga
              oshirish; <br />
              • xorijiy grantlar olish va shartnomalar tuzishda Institut
              bo'linmalariga ko'maklashish;
              <br />
              • vizalarni rasmiylashtirish, O'zbekiston Respublikasidan
              tashqaridagi xizmat safarlari uchun Institut xodimlariga hujjatlar
              to'plamini to'plash; <br />
              • institut xodimlariga buyruq tayyorlash; <br />
              • chet elga chiqayotgan Institut xodimlarining ishlarini hisobga
              olish va saqlash; <br />
              • xorijiy delegatsiyalarni qabul qilish, xalqaro konferensiyalar,
              ko'rgazmalar, forumlar, ilmiy-tadqiqot loyihalarida ishtirok etish
              va tashkil etish; <br />
              • institutning xalqaro faoliyati to'g'risida axborot, ma'lumotnoma
              va hisobot materiallarini tayyorlash. <br />
              Toshkent farmatsevtika instituti jahonning eng yuqori reytingiga
              kiritilgan 40 dan ortiq oliy o'quv yurtlari bilan o'zaro manfaatli
              hamkorlik to'g'risidagi <br /> memorandumlarni imzoladi.
            </p>
          </div>
        </div>
        <div className="mt"></div>
      </div>
      <Footer />
    </div>
  );
}

export default InterContact;
